import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import NonFederalFires from './reports/NonFederalFires';
import NonFederalRXFires from './reports/NonFederalRXFires';
import MissingAcreages from './reports/MissingAcreages';
import AcreageDiscrepancyReport from './reports/AcreageDiscrepancyReport';
import PerimeterAttributes from './reports/PerimeterAttributes';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import './ReportingDialog.css';
import { filterOperations } from '../../redux/filter';
import { incidentsOperations } from '../../redux/incidentList';
class GeneralReportingDialog extends Component {

  constructor (props)
  {
    super(props);
    this.state =
    {
      activeReport: '',
      missingPerimeterQuerying: false,
      missingPerimetersDataLoaded: false,
      missingPerimetersData: [],
      acreageDiscrepancyQuerying: false,
      acreageDiscrepancyDataLoaded: false,
      acreageDiscrepancyData: []
    };

    this.nonFederalFiresChild = React.createRef();
    this.nonFederalRXFiresChild = React.createRef();
    this.missingPerimetersChild = React.createRef();
    this.perimeterAttributesChild = React.createRef();
    this.acreageDiscrepancyChild = React.createRef();
  }

  setMissingPerimetersActive = () => {
      this.setState({ activeReport: "MissingPerimeters"});

      if (!this.state.missingPerimeterQuerying)
      {
        this.setState({missingPerimeterQuerying: true});
        window.api.getMissingPerimeterIncidents().then( results =>
        {
          this.setState(
          {
            missingPerimeterQuerying: false,
            missingPerimetersDataLoaded: true,
            missingPerimetersData: results
          });
         });
        } 
      }

      setAcreageDiscrepancyActive = () => {
        this.setState({ activeReport: "AcreageDiscrepancy"});
  
        if (!this.state.acreageDiscrepancyQuerying)
        {
          this.setState({acreageDiscrepancyQuerying: true});
          window.api.getAcreageDiscrepancyData().then( results =>
          {
            this.setState(
            {
              acreageDiscrepancyQuerying: false,
              acreageDiscrepancyDataLoaded: true,
              acreageDiscrepancyData: results
            });
           });
          } 
        }

  close = () =>
  {
    this.setState({
      activeReport: '',
      missingPerimeterQuerying: false,
      missingPerimetersDataLoaded: false,
      missingPerimetersData: [],
      acreageDiscrepancyQuerying: false,
      acreageDiscrepancyDataLoaded: false,
      acreageDiscrepancyData: []
    });

    this.props.onClose();
  }

 downloadCsv = () => {

  const reportMap = {
    NonFederalFires: this.nonFederalFiresChild,
    NonFederalRXFires: this.nonFederalRXFiresChild,
    MissingPerimeters: this.missingPerimetersChild,
    AcreageDiscrepancy: this.acreageDiscrepancyChild
  };

  const activeRef = reportMap[this.state.activeReport];
  activeRef?.current?.downloadCsv();
  }

  render() {

    const actions = [
      <FlatButton
        label="Export"
        className="reporting-print-btn"
        onClick={this.downloadCsv}
      />,
      <FlatButton
        label="Close"
        className="reporting-print-btn"
        primary={true}
        onClick={this.close}
      />
    ];

    return (
      <Dialog
        open={this.props.open}
        actions={actions}
        modal={true}
        fullScreen
        autoScrollBodyContent={true}
        contentStyle={{maxWidth: 'none', minHeight: '400'}}
        className="dialog-modal"
        >
        <AppBar position="static" className="no-print-column">
           <Toolbar variant="dense" className="no-print-column">
             <Typography variant="h6" color="inherit" className="no-print-column">
               Reports
             </Typography>
             <IconButton color="inherit" onClick={this.props.onClose} style={{position: "relative", float:"right", marginLeft:"auto"}} aria-label="close">
                <CloseIcon />
              </IconButton>
         </Toolbar>
       </AppBar>

       <Paper>
       <div className="row">
       <div className="print-column">
           <ButtonGroup
            orientation="vertical"
            color="primary"
            aria-label="vertical outlined primary button group">
          <Button color="primary" onClick={() => { this.setState({ activeReport: "NonFederalFires"})}}>Non-Federal Wildfires by Year</Button>
          <Button color="primary" onClick={() => { this.setState({ activeReport: "NonFederalRXFires"})}}>Non-Federal Prescribed Fires by Year</Button>
          <Button color="primary" onClick={this.setMissingPerimetersActive}>Missing Acreages</Button>
          <Button color="primary" onClick={this.setAcreageDiscrepancyActive}>Acreage Discrepancy</Button>
        </ButtonGroup>
        </div>
          <div className="print-column">
          <div className="big-report-page" style={{minHeight: "400px"}} >
            <NonFederalFires
             ref={this.nonFederalFiresChild}
             visible={this.state.activeReport === 'NonFederalFires'}
            />
             <NonFederalRXFires
             ref={this.nonFederalRXFiresChild}
             visible={this.state.activeReport === 'NonFederalRXFires'}
            />
            <MissingAcreages
             ref={this.missingPerimetersChild}
             isQuerying={this.state.missingPerimeterQuerying}
             dataLoaded={this.state.missingPerimetersDataLoaded}
             data={this.state.missingPerimetersData}
             visible={this.state.activeReport === 'MissingPerimeters'}
            />
             <AcreageDiscrepancyReport
             ref={this.acreageDiscrepancyChild}
             isQuerying={this.state.acreageDiscrepancyQuerying}
             dataLoaded={this.state.acreageDiscrepancyDataLoaded}
             data={this.state.acreageDiscrepancyData}
             visible={this.state.activeReport === 'AcreageDiscrepancy'}
            />
            <PerimeterAttributes
             ref={this.perimeterAttributesChild}
             visible={this.state.activeReport === 'PerimeterAttributes'}
             incidentList={this.props.incidentList}
            />
          </div>
          </div>
        </div>
        </Paper>
      </Dialog>
    )
  }
}

const mapStateToProps = state => ({
  filter: state.filter,
  incidentList: state.incidentList
})


const mapDispatchToProps = function (dispatch) {
  return bindActionCreators({
      ...filterOperations,
      ...incidentsOperations
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(GeneralReportingDialog)
